module.exports = __webpack_public_path__ + "static/img/gjgxb@2x.5e8c4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/gjgxb@2x.png
// module id = gYfT
// module chunks = 1